import { render, staticRenderFns } from "./refund-order-detail.vue?vue&type=template&id=53e6a6a5&scoped=true&"
import script from "./refund-order-detail.vue?vue&type=script&lang=js&"
export * from "./refund-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./refund-order-detail.vue?vue&type=style&index=0&id=53e6a6a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e6a6a5",
  null
  
)

export default component.exports